import { getSavedTouristsByDocType } from 'src/routes/Checkout/store/selectors/data';
import { connect } from 'react-redux';
import ShowSavedTouristButton from './ShowSavedTouristButton';

const mapStateToProps = (state, props) => {
  const { docType } = props;
  return {
    tourists: getSavedTouristsByDocType(state, docType),
  };
};

export default connect(mapStateToProps)(ShowSavedTouristButton);
